import { Controller } from "@hotwired/stimulus"

/**
 * Session Expand Controller
 *
 * Toggles visibility of child request rows within a session group
 * on the admin requests index page.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["child", "icon"]

  declare readonly childTargets: HTMLElement[]
  declare readonly iconTarget: SVGElement

  private expanded = false

  toggle(event: Event): void {
    event.stopPropagation()
    this.expanded = !this.expanded

    this.childTargets.forEach((child) => {
      child.hidden = !this.expanded
    })

    this.iconTarget.style.transform = this.expanded ? "rotate(90deg)" : ""
    this.element.setAttribute("aria-expanded", String(this.expanded))
  }
}
